/**
 * [基本信息]
 * @author: Fu Xiaochun
 * @date: 2022-05-30 
 */

import React, { useEffect, useState, useRef, forwardRef, useImperativeHandle } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { Input, Select, message, } from 'antd';
import CusotmUpload, { generateFileList } from '@/components/NewUpload';
import { findAreaByParentId } from '@/apis/common';
import * as apis from '@/apis/operation/transportCompany';
import { GenerateUUID } from '@/util/utils';

const { Option } = Select;

function BaseInfo(props, ref) {

    const [companyLogo, setCompanyLogo] = useState();  // 小运力公司logo
    const [companyName, setCompanyName] = useState();    // 小运力公司名称 
    const [contactName, setContactName] = useState();    // 联系人姓名 
    const [contactTel, setContactTel] = useState();    // 联系人手机 
    const [provinceId, setProvinceId] = useState();          // 所在省
    const [cityId, setCityId] = useState();          // 所在市
    const [areaId, setAreaId] = useState();          // 所在区
    const [address, setAddress] = useState();          // 详细地址

    const [provinces, setProvinces] = useState([]); // 省列表
    const [cities, setCities] = useState([]); // 市列表
    const [areas, setAreas] = useState([]); // 区列表

    const $ocPage = useRef({ pageNum: 1, pageSize: 10 });
    const ocLoading = useRef(false);
    const [OCList, setOCList] = useState([]);   //运营中心列表
    const [OC, setOC] = useState({});  // 运营中心
    const authInfo = useRef(JSON.parse(localStorage.getItem('auth') || '{}'));

    useEffect(() => {
        if (props.detail.id) {
            initData();
        }
    }, [props]);

    useEffect(() => {

        // 获取省列表
        // getAreasByParentId(0, setProvinces);
        getOperatingCenterList();

        if (authInfo.userInfo?.accountType == 'COMPANY') {
            setOC({ label: authInfo.userInfo?.companyName, value: authInfo.userInfo?.companyId });
        }
    }, []);

    useEffect(() => {
        if (OC.value) {
            getAreasByCompanyId();
        }
    }, [OC]);

    const initData = () => {
        let detail = props.detail;
        setCompanyLogo({ uid: GenerateUUID(), url: detail.transportLogo });
        setCompanyName(detail.transportName);
        setContactName(detail.contactName);
        setContactTel(detail.tel);
        setAddress(detail.address);
        setOC({ value: detail.opId, label: detail.opName });
    };

    const getAreasByCompanyId = () => {
        apis.getCompanyAreas({ id: OC.value }).then(res => {
            let list = res.result || [];
            setProvinceId();
            setCityId();
            setAreaId();
            setCities([]);
            setAreas([]);
            const areaTree = formatAreaTree(list);
            setProvinces(areaTree);
        }).catch(err => {
            message.error(err.message);
        });
    };

    const formatAreaTree = (data) => {
        const provinceMap = new Map();

        data.forEach(item => {
            const { provinceId, provinceName, cityId, cityName, areaId, areaName } = item;

            // 省
            if (!provinceMap.has(provinceId)) {
                provinceMap.set(provinceId, {
                    id: provinceId,
                    areaName: provinceName,
                    children: []
                });
            }

            const province = provinceMap.get(provinceId);

            // 市
            let city = province.children.find(c => c.id === cityId);
            if (!city) {
                city = {
                    id: cityId,
                    areaName: cityName,
                    children: []
                };
                province.children.push(city);
            }

            // 区（去重）
            if (!city.children.find(a => a.id === areaId)) {
                city.children.push({
                    id: areaId,
                    areaName
                });
            }
        });

        return Array.from(provinceMap.values());
    };

    const companyLogoChange = (data = {}) => {
        let imgs;
        if (Array.isArray(data.fileList)) {
            data.fileList.forEach(v => {
                if (v.status == 'success') {
                    imgs = v;
                }
            });
        }
        setCompanyLogo(imgs);
    };

    const onContactTelBlur = (e) => {
        let val = e.target.value.replace(/\D/g, '').substr(0, 11);
        setContactTel(val);
    };

    const onProvinceChoose = (val) => {
        console.log(val);
        setProvinceId(val);
        setCityId();
        setAreaId();
        setAreas([]);
        const provinceItem = provinces.find(v => v.id == val) || {};
        setCities(provinceItem.children);

        // getAreasByParentId(val, setCities);
    };

    const onCityChoose = (val) => {
        setCityId(val);
        setAreaId();
        const cityItem = cities.find(v => v.id == val) || {};
        setAreas(cityItem.children);
    };

    useImperativeHandle(ref, () => ({
        getState: () => {
            return {
                companyLogo: companyLogo?.url,
                companyName,
                contactName,
                contactTel,
                provinceId,
                cityId,
                areaId,
                address,
                opId: OC.value
            };
        }
    }));

    const getOperatingCenterList = (data = {}) => {
        let params = {
            companyName: data.companyName,
            pageSize: $ocPage.current.pageSize,
            pageNum: $ocPage.current.pageNum
        };
        apis.getOperatingCenterList(params).then(res => {
            let list = [...OCList];
            let _list = res.result.dataList || [];

            if ($ocPage.current.pageNum > 1) {
                list = list.concat(..._list);
            } else {
                list = _list;
            }
            // list = list.map(v => ({ value: v.companyName, code: v.companyId }));
            setOCList(list);
        }).catch(err => {
            message.error(err.message);
        });
    };


    const onOCListScroll = (e) => {
        e.persist();
        const { target } = e;
        if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
            if (!ocLoading.current) {
                $ocPage.current.pageNum = $ocPage.current.pageNum + 1;
                getOperatingCenterList();
            }
        }
    };

    const onOCListSearch = (val) => {
        let reg = /^[\u4e00-\u9fa5]{1,40}$/;
        $ocPage.current.pageNum = 1;
        if (reg.test(val)) {
            getOperatingCenterList({ companyName: val });
        } else {
            getOperatingCenterList();
        }
    };

    const onOCListFocus = (e) => {
        e.target.scrollTop = 0;
        $ocPage.current.pageNum = 1;
        getOperatingCenterList();
    };

    return (
        <div className={styles.baseInfo}>
            <div className={styles.item}>
                <div className={styles.label}>站点图标：</div>
                <div className={styles.val} style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                    <div style={{ width: '110px', height: '104px' }}>
                        <CusotmUpload accept='.png, .jpg, .jpeg' listType='picture-card' wallMode='single'
                            fileList={companyLogo ? [companyLogo] : null}
                            onFileListChange={companyLogoChange}
                            removeError
                            qiniuUploadProps={{ uploadType: 'image' }}
                            beforeUpload={file => {
                                const isType = ['image/png', 'image/jpeg', 'image/jpg'];
                                const isLt5M = file.size / 1024 / 1024 > 5;
                                if (!isType.includes(file.type)) {
                                    message.warn('只能上传PNG、JPG、JPEG格式的图片!');
                                    file.status = 'error';
                                    return false;
                                } else if (isLt5M) {
                                    message.warn('图片必须小于 5MB!');
                                    file.status = 'error';
                                    return false;
                                }
                            }}
                        >
                            <div style={{ color: '#999999', fontSize: '12px' }}>上传logo</div>
                        </CusotmUpload>
                    </div>
                    <div className={styles.extTxt}>仅支持PNG、JPG、JPEG格式，不大于5M的照片</div>
                </div>
            </div>
            <div className={styles.item}>
                <div className={styles.label}>站点名称：</div>
                <div className={styles.val}>
                    <Input className={styles.txt} allowClear value={companyName} placeholder="请输入站点名称" maxLength={20} onChange={e => { setCompanyName(e.target.value.trim()); }} />
                </div>
            </div>
            <div className={styles.item}>
                <div className={styles.label}>联系人姓名：</div>
                <div className={styles.val}>
                    <Input className={styles.txt} allowClear value={contactName} placeholder="请输入联系人姓名" maxLength={10} onChange={e => { setContactName(e.target.value.trim()); }} />
                </div>
            </div>
            <div className={styles.item}>
                <div className={styles.label}>联系人手机：</div>
                <div className={styles.val}>
                    <Input className={styles.txt} allowClear value={contactTel} placeholder="请输入联系人手机" maxLength={11} onBlur={onContactTelBlur} onChange={e => { setContactTel(e.target.value.trim()); }} />
                    <div className={styles.extTxt}>用于登录的账号</div>
                </div>
            </div>
            <div className={styles.item}>
                <div className={styles.label}>运营中心：</div>
                <div className={styles.val}>
                    <Select placeholder='请选择' className={styles.selectInput} allowClear showSearch
                        disabled={authInfo.userInfo?.accountType == 'COMPANY'}
                        onFocus={onOCListFocus}
                        onSearch={onOCListSearch}
                        onPopupScroll={onOCListScroll}
                        onChange={val => { setOC(val || {}); }}
                        value={OC}
                        optionFilterProp="children"
                        labelInValue={true}
                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                    >
                        {OCList.map((item, index) => <Option key={item.companyId} value={item.companyId} >{item.companyName}</Option>)}
                    </Select>
                </div>
            </div>
            <div className={styles.item} style={{ width: '100%', clear: 'left' }}>
                <div className={styles.label}>所在区域：</div>
                <div className={styles.val}>
                    <Select placeholder='请选择省份' style={{ width: '120px' }} onChange={onProvinceChoose} value={provinceId}>
                        {provinces.map(item => <Option key={item.id} value={item.id} >{item.areaName}</Option>)}
                    </Select>
                    <Select placeholder='请选择城市' style={{ width: '150px', marginLeft: '10px' }} onChange={onCityChoose} value={cityId}>
                        {cities.map(item => <Option key={item.id} value={item.id} >{item.areaName}</Option>)}
                    </Select>
                    <Select placeholder='请选择区县' style={{ width: '120px', marginLeft: '10px' }} onChange={setAreaId} value={areaId}>
                        {areas.map(item => <Option key={item.id} value={item.id} >{item.areaName}</Option>)}
                    </Select>
                </div>
            </div>
            <div className={styles.item} style={{ width: '100%', clear: 'left' }}>
                <div className={styles.label}>详细地址：</div>
                <div className={styles.val}>
                    <Input style={{ width: '500px' }} allowClear value={address} placeholder="请输入站点详细地址" maxLength={50} onChange={e => { setAddress(e.target.value.trim()); }} />
                </div>
            </div>
        </div>
    );
}

const RefBaseInfo = forwardRef(BaseInfo);

BaseInfo.propTypes = {
    detail: PropTypes.object,
};

BaseInfo.defaultProps = {
    detail: {}
};


export default RefBaseInfo;